module.exports = __webpack_public_path__ + "img/two-credit-cards.a7d0f630.svg";